"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _PatientDetailsNotes = require("./PatientDetailsNotes");
Object.keys(_PatientDetailsNotes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PatientDetailsNotes[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _PatientDetailsNotes[key];
    }
  });
});